export default {"src":"/_next/static/media/HeaderArrowIcon.e33848e0.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};